import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'unit',
    serviceName: 'graphql',
    query: gql`
      query unit($ids: [String], $for_admin: Int) {
        unit(ids: $ids, for_admin: $for_admin) {
          data {
            title
            is_active
            manager {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateUnit',
    serviceName: 'unitadmin',
    query: gql`
      mutation updateUnit(
        $ids: [String]!
        $title: String
        $lat: String
        $lng: String
        $is_active: Int
        $manager_id: String
      ) {
        updateUnit(ids: $ids, title: $title, lat: $lat, lng: $lng, is_active: $is_active, manager_id: $manager_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
